export default "__VITE_ASSET__CdaKnMEw__"